import 'polyfill';

// lock header width on sticky header, no longer constrained by table layout
function lockChildren(node) {
  Array.from(node.children).forEach(function(tr) {
    var width = Math.round(tr.getBoundingClientRect().width);
    tr.style.minWidth = width + 'px';
    tr.style.maxWidth = width + 'px';
    lockChildren(tr);
  });
}
// remove inline widths to allow resizing when the window changes
function clearChildren(node) {
  Array.from(node.children).forEach(function(tr) {
    tr.removeAttribute('style');
    clearChildren(tr);
  });
}
function singleStickyHeader() {
  var header;
  var table;
  var scrollBreakPoint;
  var resizeTimer;
  var floater;
  var screenWidth;
  var tableBottom;
  var headerHeight;
  var creationTimer;

  var startingRecalculateWait = 100;
  var maxRecalculateWait = 60000;
  var recalculateBreakPointHandle;
  
  function cleanUpListeners() {
    window.removeEventListener('scroll', scrollHandler);
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('load', calculateBreakPoint);
    clearTimeout(recalculateBreakPointHandle)
  }
  function calculateBreakPoint() {
    var scrollPos = window.pageYOffset;
    var headerBox = header.getBoundingClientRect();
    headerHeight = headerBox.height;
    scrollBreakPoint = headerBox.top + scrollPos;
  }

  // Still seeing image jump break the breakpoint calculation infrequently.
  // Trying a simpler setTimeout approach because turbolinks may be breaking the browser image 'load' event strategy
  // https://trello.com/c/RPmrOnnM/584-jeff-sticky-header-issue
  function recalculateBreakPoint(previousWait) {
    calculateBreakPoint();
    var wait = previousWait * 2;
    if (wait < maxRecalculateWait) {
      recalculateBreakPointHandle = setTimeout(() => recalculateBreakPoint(wait), wait);
    }
  }
  function createFloater() {
    resizeTimer = undefined;
    header = document.getElementById('TableHeader');
    table = document.getElementById('Table');
    if (header && table) {
      cleanUpListeners();
      lockChildren(header);
      var scrollPos = window.pageYOffset;
      if (floater) {floater.remove(); }
      floater = header.cloneNode(true);
      floater.className = floater.className + ' fixed-header';
      screenWidth = window.innerWidth;
      recalculateBreakPoint(startingRecalculateWait);

      // Recalculate sticky breakpoint whenever an image is loaded into the page
      // https://trello.com/c/8qaCipPj/543-resources-sticky-header-bug
      window.addEventListener('load', calculateBreakPoint);

      tableBottom = table.getBoundingClientRect().bottom + scrollPos;
      window.addEventListener('scroll', scrollHandler, false);
      window.addEventListener('resize', resizeHandler, false);
    }
    scrollHandler();
  }
  function scrollHandler() {
    if (floater && !resizeTimer) {
      if (window.pageYOffset > scrollBreakPoint && window.pageYOffset < tableBottom - headerHeight) {
        table.appendChild(floater);
      } else {
        floater.remove();
      }
    }
  }
  function resizeHandler() {
    if (header && screenWidth !== window.innerWidth) {
      floater.remove();
      clearChildren(header);
      if (resizeTimer) { clearTimeout(resizeTimer); }
      resizeTimer = setTimeout(createFloater, 100);
    }
  }
  function scheduleCreation() {
    clearTimeout(creationTimer);
    creationTimer = setTimeout(createFloater, 500);
  }
  document.addEventListener('turbolinks:load', scheduleCreation);
  document.addEventListener('turbolinks:before-render', cleanUpListeners);
}
function mobileStickyHeaders() {
  var headerHeight = 52; // 44 height, 3px padding , 1 px border
  var headers;
  var tables;
  var scrollBreakPoints;
  var resizeTimer;
  var floaters;
  var screenWidth;
  var tableBottom;
  var tableBottoms;
  var lastScroll;
  var creationTimer;
  function cleanUpListeners() {
    // window.removeEventListener('scroll', scrollHandler);
    window.removeEventListener('resize', resizeHandler);
  }
  function createFloaters() {
    resizeTimer = undefined;
    tables = Array.from(document.querySelectorAll('.mobile-table.sticky'));
    if (tables && tables.length) {
      cleanUpListeners();
      headers = tables.map(function(table) { return table.getElementsByTagName('thead')[0]; });
      headers.forEach(lockChildren);
      if (floaters && floaters.length) {
        floaters.forEach(function(floater) {
          floater.remove();
        });
      }
      floaters = headers.map(function(header) {
        var floater = header.cloneNode(true);
        floater.className = floater.className + ' fixed-header';
        return floater;
      });
      screenWidth = window.innerWidth;
      var scrollPos = window.pageYOffset;
      tableBottom = headers[headers.length - 1].parentElement.getBoundingClientRect().bottom + scrollPos;
      var headerBoxes = headers.map(function(header) { return header.getBoundingClientRect(); });
      scrollBreakPoints = headerBoxes.map(function(box) { return box.top + scrollPos; });
      tableBottoms = headers.map(function(header) { return header.parentElement.getBoundingClientRect().bottom + scrollPos; });
      // window.addEventListener('scroll', scrollHandler, false);
      window.requestAnimationFrame(scrollHandler);
      window.addEventListener('resize', resizeHandler, false);
    }
    scrollHandler();
  }
  function scrollHandler() {
    if (tables && tables.length && !resizeTimer) {
      if (lastScroll !== window.pageYOffset) {
        lastScroll = window.pageYOffset;
        tables.forEach(function(table, i) {
          if (window.pageYOffset < tableBottom && window.pageYOffset > scrollBreakPoints[i]) {
            if (!table.contains(floaters[i])) { table.appendChild(floaters[i]); }
            floaters[i].style.transform = `translateY(${Math.min(0, tableBottoms[i] - window.pageYOffset - headerHeight)}px)`;
            floaters[i].style['-webkit-transform'] = `translateY(${Math.min(0, tableBottoms[i] - window.pageYOffset - headerHeight)}px)`;
          } else {  
            if (table.contains(floaters[i])) { floaters[i].remove(); }
          }
        });
      }
      window.requestAnimationFrame(scrollHandler);
    }
  }
  function resizeHandler() {
    if (headers && headers.length && screenWidth !== window.innerWidth) {
      if (floaters) { floaters.forEach(function(floater) { floater.remove(); }); }
      floaters = undefined;
      headers.forEach(clearChildren);
      if (resizeTimer) { clearTimeout(resizeTimer); }
      resizeTimer = setTimeout(createFloaters, 100);
    }
  }
  function scheduleCreation() {
    clearTimeout(creationTimer);
    creationTimer = setTimeout(createFloaters, 500);
  }
  // without implementing the timeout, table header positions are off by something like (n * 5)px; unsure why
  document.addEventListener('turbolinks:load', scheduleCreation);
  document.addEventListener('turbolinks:before-render', cleanUpListeners);
}
singleStickyHeader();
mobileStickyHeaders();
